// extracted by mini-css-extract-plugin
export default {"container":"_0PFMY6p+D3","logo-container":"BHcZ7+3uCX","logoContainer":"BHcZ7+3uCX","logo":"sOkReoN7Kl","brand-logo":"-BC0WFGKpO","brandLogo":"-BC0WFGKpO","brand-logo-container":"EcpEgJspsa","brandLogoContainer":"EcpEgJspsa","vertical":"u8j8EtTL8M","custom-branding":"_0gXXQk7WVi","customBranding":"_0gXXQk7WVi"};
    if(module.hot) {
      // 1648553719449
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  